/*
 * @Author: niuqingxia
 * @Date: 2024-12-19 10:50:18
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-12-Tu 09:47:53
 筛选框组件(提供日期、省、省市、省市区的筛选功能)
 */

<template>
  <div class="filter-block">
    <!-- 日期 -->
    <template v-if="filterType === 'date'">
      <el-date-picker
        v-model="datePick"
        class="filter-item"
        :clearable="false"
        :style="{
          backgroundColor: config.chartSet.chartStyle.backgroundColor,
          borderColor: config.chartSet.chartStyle.borderColor,
          fontSize: config.chartSet.chartStyle.fontSize + 'px',
          color: config.chartSet.chartStyle.color,
        }"
        type="monthrange"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleSearch">
      </el-date-picker>
    </template>

    <!-- 省、省市、省市区 -->
    <template v-if="filterType !== 'date'">
      <el-cascader
        v-model="province"
        class="filter-item"
        :placeholder="filterAreaMap.get(filterType).placholder"
        clearable
        :options="showRegionInfo"
        :props="{
          value: 'code',
          multiple: false,
          emitPath: false,
          label: 'name',
          children: 'children',
          checkStrictly: false,
        }"
        :filterable="$route.path.includes('/view/')"
        :style="{
          backgroundColor: config.chartSet.chartStyle.backgroundColor,
          border: `1px solid ${config.chartSet.chartStyle.borderColor}`,
          borderRadius: '2px',
          fontSize: config.chartSet.chartStyle.fontSize + 'px',
          color: config.chartSet.chartStyle.color,
          width: '100%',
        }"
        :disabled="isDisabled"
        @change="handleSearch">
      </el-cascader>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Request from 'src/utils/request'
export default {
  name: 'FilterBlock',
  props: {
    config: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    globalConfig: {
      type: Object,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const initFilterForm = {
      startTime: '',
      endTime: '',
      provinceCode: '',
      cityCode: '',
      regionCode: '',
    }
    const filterAreaMap = new Map([
      ['province', { placholder: '省', level: 1 }],
      ['city', { placholder: '省市', level: 2 }],
      ['region', { placholder: '省市区', level: 3 }],
    ])
    const initDate = [
      dayjs().subtract(6, 'month').format('YYYY-MM-') + '01',
      dayjs().format('YYYY-MM-DD'),
    ]
    return {
      // 默认筛选时间
      initDate,
      datePick: [...initDate],
      initFilterForm: _.cloneDeep(initFilterForm),
      filterForm: _.cloneDeep(initFilterForm),
      provinceList: [],
      // 日期选择快捷选项
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = dayjs(dayjs().format('YYYY-MM') + '-01').toDate()
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '今年',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear() + '-01-01')
            picker.$emit('pick', [start, end])
          },
        }],
      },
      province: [],
      filterAreaMap,
      showRegionInfo: [],
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters(['regionInfo']),
    filterType () {
      return this.config.chartSet.chartStyle.filterType
    },
    combinedVars () {
      return [this.regionInfo, this.filterType]
    },
    chartData () {
      return this.config.chartViewData.chartData
    },
  },
  watch: {
    combinedVars: {
      handler (newValue) {
        const [regionInfo, filterType] = newValue
        if (filterType === 'date') {
          this.showRegionInf = []
          return
        }
        if (regionInfo) {
          const level = this.filterAreaMap.get(filterType).level
          if (level === 3) {
            this.showRegionInfo = _.cloneDeep(regionInfo)
          } else {
            const data = this.getChildTree(regionInfo, level)
            this.showRegionInfo = _.cloneDeep(data)
          }
        }
      },
      immediate: true,
    },
  },
  created () {
    this.$store.dispatch('district/getRegionInfo')
  },
  beforeDestroy () {
    this.datePick = ''
    this.filterForm = _.cloneDeep(this.initFilterForm)
    this.handleSearch()
  },
  methods: {
    init () {
      const filterParams = this.globalConfig.filterParams ? JSON.parse(this.globalConfig.filterParams) : {}
      if (!Object.keys(filterParams).length) {
        return
      }
      const { startTime, endTime, provinceCode, cityCode, regionCode } = filterParams
      this.datePick = startTime && endTime ? [new Date(startTime), new Date(endTime)] : [...this.initDate]
      this.province = regionCode || (cityCode || provinceCode)
      this.filterForm = _.cloneDeep(filterParams)
      this.$emit('filterChange', {
        ...filterParams,
        addSn: this.config.addSn,
      })
    },
    // 筛选
    async handleSearch () {
      let params
      switch (this.filterType) {
        case 'date':
          {
            const startTime = this.datePick ? this.datePick[0] : ''
            const endTime = this.datePick ? this.datePick[1] : ''
            params = { startTime, endTime }
            this.filterForm.startTime = startTime
            this.filterForm.endTime = endTime
          }

          break
        case 'province':
          this.filterForm.provinceCode = this.province
          this.filterForm.cityCode = ''
          this.filterForm.regionCode = ''
          params = {
            provinceCode: this.province,
            cityCode: '',
            regionCode: '',
          }
          break
        case 'city': {
          const currentPath = this.getPathById(this.showRegionInfo, this.province)
          this.filterForm.provinceCode = currentPath?.[0]?.code
          this.filterForm.cityCode = currentPath?.[1]?.code
          this.filterForm.regionCode = ''
          params = {
            provinceCode: currentPath?.[0]?.code,
            cityCode: currentPath?.[1]?.code,
            regionCode: '',
          }
        }
          break
        case 'region':
          {
            const currentPath = this.getPathById(this.showRegionInfo, this.province)
            this.filterForm.provinceCode = currentPath?.[0]?.code
            this.filterForm.cityCode = currentPath?.[1]?.code
            this.filterForm.regionCode = currentPath?.[2]?.code
            params = {
              provinceCode: currentPath?.[0]?.code,
              cityCode: currentPath?.[1]?.code,
              regionCode: currentPath?.[2]?.code,
            }
          }
          break
        default:
          params = {}
          break
      }
      this.config.chartViewData.chartData = params
      const data = _.cloneDeep(this.config.chartViewData)
      data.chartData = JSON.stringify(params)
      // this.saveData(data)
      this.$emit('filterChange', {
        ...params,
        addSn: this.config.addSn,
      })
    },
    clearDate () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    // 获取树的某一层子树
    getChildTree (tree, depth) {
      if (depth <= 0 || !Array.isArray(tree)) return []
      return tree.map(node => {
        const newNode = { name: node.name, code: node.code }
        if (depth > 1 && node.children) {
          newNode.children = this.getChildTree(node.children, depth - 1)
        }
        return newNode
      })
    },
    getPathById (tree, targetId) {
      const path = []
      function traverse (nodes, currentPath) {
        for (const node of nodes) {
          const newPath = [...currentPath, { name: node.name, code: node.code }]
          if (node.code === targetId) {
            path.push(...newPath)
            return true // 找到目标节点，停止递归
          }
          if (node.children && traverse(node.children, newPath)) {
            return true // 如果目标节点在子节点中，停止递归
          }
        }
        return false
      }

      traverse(tree, [])
      return path
    },
    saveData (data) {
      Request({
        url: '/panel/chart_data',
        method: 'post',
        data,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-block{
  height: 100%;
  ::v-deep .filter-item{
    height: 100%;
    width: 100%;
    .el-range-input,.el-range-separator{
      background-color: transparent;
      font-size: inherit;
      color: inherit;
    }
    .el-input{
      font-size: inherit;
      color: inherit;
      height: inherit;
      .el-input__inner{
        background-color: inherit !important;
        border: none;
        font-size: inherit;
        color: inherit;
        height: inherit;
      }
    }
    .el-range-separator{
      display: flex;
      align-items: center;
    }
  }
}
</style>
